<!-- =========================================================================================
  File Name: UserEdit.vue
  Description: User Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div >
    <vs-alert color="danger" title="Personel Bulunamadı" :active.sync="user_not_found">
      <span>User record with id: {{ $route.params.userId }} not found.</span>
      <span>
        <span>Check</span>
        <router-link :to="{name:'page-user-list'}" class="text-inherit underline">All Users</router-link>
      </span>
    </vs-alert>
    <vx-card v-if="user_data">
      <div slot="no-body" class="tabs-container px-6 pt-6">
        <vs-tabs v-model="activeTab" >
          <vs-tab label="Hesap" icon-pack="feather" icon="icon-user">
            <div class="tab-text">
              <user-edit-tab-account class="mt-4" :data="user_data" />
            </div>
          </vs-tab>
          <vs-tab label="Kişisel Bilgiler" icon-pack="feather" icon="icon-info">
            <div class="tab-text">
              <user-edit-tab-information class="mt-4" :data="user_data" />
            </div>
          </vs-tab>
         
        </vs-tabs>
      </div>
    </vx-card>
  </div>

</template>

<script>
import UserEditTabAccount from "./UserEditTabAccount.vue";
import UserEditTabInformation from "./UserEditTabInformation.vue";
import { repository } from "@/_services/repository.js";

export default {
  components: {
    UserEditTabAccount,
    UserEditTabInformation
  },
  data() {
    return {
      user_data: {},
      user_not_found: false,

      /*
        This property is created for fetching latest data from API when tab is changed

        Please check it's watcher
      */
      activeTab: 0
    };
  },
  watch: {
    activeTab() {
      // this.fetch_user_data();
    }
  },
  created() {
    this.$on("getUserId", function(id) {
      
    });

    // this.fetch_user_data()


    
  },
  methods:{
    fetch_user_data: async function(){
       await repository
      .getById("User/getUser", this.$route.params.userId)
      .then(r => (this.user_data = r.entity))
      .catch(err => {
        if (err.response.status === 404) {
          this.user_not_found = true;
          return;
        }
        //console.error(err);
      });

    }
  }
};
</script>
